export enum CreditNoteTabsEnum {
  POSITIONS = 'positions',
  BILLING_INFORMATION = 'billing information',
  FILE = 'file',
  DOCUMENTS = 'documents',
  PREFERENCES = 'preferences',
}
